import React from "react";

/* Einheitlicher Strich-Icon-Satz für die Kenntnisse-Seite.
   Alle auf 24er-Raster, gleiche Strichstärke – Font Awesome mischte
   gefüllte und gestrichelte Formen, das wirkte unruhig. */
const paths = {
  language: (
    <path d="M21 11.5a8.5 8.5 0 0 1-9.1 8.5 9.3 9.3 0 0 1-4-1L3 20.5l1.5-4.3a8.4 8.4 0 0 1-1.5-4.7 8.5 8.5 0 0 1 9-8.5 8.5 8.5 0 0 1 9 8.5z" />
  ),
  scale: (
    <>
      <path d="M12 4v16M7 20h10M5 8h14l-2-3H7z" />
      <path d="M5 8l-2.5 5.5a3 3 0 0 0 5 0L5 8zM19 8l-2.5 5.5a3 3 0 0 0 5 0L19 8z" />
    </>
  ),
  chart: <path d="M3 21h18M6.5 21v-7M11.5 21V7M16.5 21v-10M21 21V4" />,
  repeat: (
    <>
      <path d="M17 2.5 21 6.5l-4 4" />
      <path d="M3 11.5v-1a4 4 0 0 1 4-4h14" />
      <path d="M7 21.5 3 17.5l4-4" />
      <path d="M21 12.5v1a4 4 0 0 1-4 4H3" />
    </>
  ),
  check: (
    <>
      <path d="M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9" />
      <path d="M8.5 11.5 12 15l9-9" />
    </>
  ),
  document: (
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5M9 13h6M9 17h4" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z" />
    </>
  ),
  briefcase: (
    <>
      <rect x="2.5" y="7" width="19" height="13.5" rx="2" />
      <path d="M16 20.5V5.5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v15M2.5 12.5h19" />
    </>
  ),
  pie: (
    <>
      <path d="M21.2 15.9A10 10 0 1 1 8.1 2.8" />
      <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </>
  ),
  zap: <path d="M13 2.5 3.5 14H11l-1 7.5L20.5 10H13z" />,
  layers: (
    <>
      <path d="M12 2.5 22 7.5l-10 5-10-5z" />
      <path d="M2 16.5l10 5 10-5M2 12l10 5 10-5" />
    </>
  ),
  database: (
    <>
      <ellipse cx="12" cy="5.5" rx="8.5" ry="3" />
      <path d="M3.5 5.5v13c0 1.7 3.8 3 8.5 3s8.5-1.3 8.5-3v-13" />
      <path d="M3.5 12c0 1.7 3.8 3 8.5 3s8.5-1.3 8.5-3" />
    </>
  ),
  terminal: <path d="M4 17.5 10 12 4 6.5M12.5 19h7.5" />,
  video: (
    <>
      <rect x="2.5" y="6" width="13.5" height="12" rx="2" />
      <path d="M21.5 8 16 12l5.5 4z" />
    </>
  ),
  activity: <path d="M22 12h-4l-3 8.5L9 3.5 6 12H2" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20.5 20.5 16 16" />
    </>
  ),
  bulb: (
    <>
      <path d="M9.5 18.5h5M10.5 21.5h3" />
      <path d="M15.2 14.3a5.5 5.5 0 1 0-6.4 0c.7.5 1.1 1.3 1.2 2.1h4c.1-.8.5-1.6 1.2-2.1z" />
    </>
  ),
  sitemap: (
    <>
      <rect x="9" y="2.5" width="6" height="5" rx="1.5" />
      <rect x="2" y="16.5" width="6" height="5" rx="1.5" />
      <rect x="16" y="16.5" width="6" height="5" rx="1.5" />
      <path d="M12 7.5v4M5 16.5V12h14v4.5" />
    </>
  ),
  users: (
    <>
      <path d="M15.5 21v-1.8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V21" />
      <circle cx="8.75" cy="7.5" r="3.75" />
      <path d="M22 21v-1.8a4 4 0 0 0-3-3.85M15.5 4a3.75 3.75 0 0 1 0 7" />
    </>
  ),
};

export const Icon = ({ name, className }) => {
  const shape = paths[name];
  if (!shape) return null;

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {shape}
    </svg>
  );
};

export default Icon;
